<template>
    <div class="tencentInformSetting">
        <div class="generalize">
            <div class="title">推广通知</div>
            <div class="generalizeBtn">
                <el-radio v-model="params.isopennotify" :label="1">开启 <span class="openTips">（开启后，推广员可关注服务号，接收关系绑定、收益通知。1个推广员每天最多接收3条通知，点击<span>查看详情</span>)</span></el-radio>
                <br>
                <el-radio v-model="params.isopennotify" :label="0">关闭</el-radio>
            </div>
        </div>
        <div class="auditResult">
            <div class="title">审核结果通知</div>
            <div class="text">
                <span class="result">已开启</span>
                <span class="resultTips">（开启后，已关注公众号的用户，可以接收到【审核成功/审核失败的通知】）</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'tencentInformSetting',
    data() {
        return {
            params: {
                isopennotify: 1
            }
        }
    },
    props: ['data'],
    created() {
    },
    watch: {
        'data': {
            handler() {
                for (let key in this.params) {
                    this.params[key] = this.data[key]
                }
            },
            deep: true
        }
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .tencentInformSetting{
        .generalize, .auditResult{
            display: flex;
            margin-top: 20px;
            .title{
                width: 84px;
                margin-right: 40px;
                color: #606266;
            }
            .generalizeBtn{
                .el-radio{
                    margin-bottom: 15px;
                    .openTips{
                        color: #909399;
                        margin-left: 20px;
                        span{
                            color: #409EFF;
                        }
                    }
                }
                .el-radio__input.is-checked+.el-radio__label{
                    color: #303133;
                }
            }
            .text{
                .resultTips{
                    color: #909399;
                    margin-right: 20px;
                }
            }
        }
    }
</style>